function LoaderSpin({ show = true, width = 5, height = 5, wrapperClass = 'bg-white', spinClass = 'border-t-black' }) {
  return (
    show && (
      <div className={`fit flex-center z-20 ${wrapperClass}`}>
        <div className={`relative w-${width} h-${height}`}>
          <div className={`fit border-blue animate-loading-spin rounded-full border-2  ${spinClass}`}></div>
        </div>
      </div>
    )
  )
}

export default LoaderSpin
